

























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { ISignUpFields, ICognitoSignUpFields } from '@/common/types';

// components
import Base from '@/components/Login/Base.vue';
import Welcome from '@/components/Global/Welcome.vue';
import Validation from '@/components/Form/Validation.vue';
import TextField from '@/components/Form/TextField.vue';
import Alert from '@/components/Global/Alert.vue';
import SelectField from '@/components/Form/SelectField.vue';
import RadioField from '@/components/Form/RadioField.vue';
import Checkbox from '@/components/Form/Checkbox.vue';
// Services
import router from '../../router';
import Brand from '@/services/Brand';
import store from '@/store';
import AuthService from '@/services/Auth';
import ProgressTrackerDesktop from './ProgressTracker.vue';

// validations
import { helpers } from 'vuelidate/lib/validators';
import { hasUppercase, hasLowercase, hasNumber, hasSpecialCharacter } from '@/validations';
import { required, email, sameAs, minLength, requiredIf } from 'vuelidate/lib/validators';

const pwdReq = helpers.regex(
	'pwdReq',
	/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{10,}$/,
);

@Component({
	name: 'ResetPassword',
	components: {
		TextField,
		Alert,
		Validation,
		SelectField,
		RadioField,
		Base,
		Welcome,
		Checkbox,
		ProgressTrackerDesktop,
	},
	validations: {
		form: {
			password: {
				required,
				minLength: minLength(10),
				hasUppercase,
				hasLowercase,
				hasNumber,
				hasSpecialCharacter,
			},
			confirmPassword: {
				required,
				sameAsPassword: sameAs('password'),
			},
			code: {
				required,
			},
		},
	},
})
export default class ResetPassword extends Vue {
	private error: string | boolean;
	private sent: boolean;
	private loading: boolean;
	private isInvalid: boolean;
	private logger: any;
	private form: any;
	constructor() {
		super();

		this.isInvalid = false;

		this.form = {
			password: '',
			confirmPassword: '',
			code: '',
		};
	}

	private isInValid() {
		return this.$v.$invalid;
	}

	get details() {
		return Brand.getBrandInformation();
	}
	private verify() {
		this.$Amplify.Auth.configure({
			authenticationFlowType: 'USER_SRP_AUTH',
			clientMetadata: {
				brand: Brand.getBrand(),
			},
		});
		this.$Amplify.Auth.forgotPasswordSubmit(
			this.options.email,
			this.form.code,
			this.form.password,
		)
			.then(() => {
				window.changePassword = true;
				this.$router.push({
					name: 'login',
				});
			})
			.catch(e => {
				this.loading = false;
				this.setError(e);
				// SentryCaptureException(e);
			});
	}
	get options(): any {
		const defaults = {
			email: '',
		};
		return Object.assign(defaults, this.$route.params.config || {});
	}

	private setError(e) {
		this.error = e.message || e;
		window.scrollTo(0, 0);
	}
}
